import { Routes } from '@angular/router';
import { CompanyComponent } from './company/company.component';
import { CompanyConsentComponent } from './company/pages/company-consent/company-consent.component';
import { LoginType } from './constants/login-type.enum';
import { InvestorComponent } from './investor/investor.component';
import { InvestorConsentComponent } from './investor/pages/investor-consent/investor-consent.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout/login-layout.component';
import { LoginAdminComponent } from './login-admin/login-admin.component';
import { LoginComponent } from './login/login.component';
import { ScheduleCompanyComponent } from './schedule-company/schedule-company.component';
import { ScheduleInvestorComponent } from './schedule-investor/schedule-investor.component';
import { AuthGuardGuard } from './shared/services/auth-guard.guard';
import { UnauthorizeComponent } from './unauthorize/unauthorize.component';
const ɵ0 = () => import("./register-company/register-company.module.ngfactory").then(m => m.RegisterCompanyModuleNgFactory), ɵ1 = () => import("./register-investor/register-investor.module.ngfactory").then(m => m.RegisterInvestorModuleNgFactory), ɵ2 = () => import("./register-seminar-investor/register-seminar-investor.module.ngfactory").then(m => m.RegisterSeminarInvestorModuleNgFactory), ɵ3 = {
    loginType: LoginType.company,
    showHeader: true,
    showUserInfo: false
}, ɵ4 = {
    loginType: LoginType.investor,
    showHeader: true,
    showUserInfo: false
}, ɵ5 = {
    loginType: LoginType.company,
    showHeader: false
}, ɵ6 = {
    loginType: LoginType.investor,
    showHeader: false
}, ɵ7 = { loginType: LoginType.admin }, ɵ8 = { showHeader: false }, ɵ9 = { showHeader: true }, ɵ10 = { showHeader: false }, ɵ11 = { showHeader: true }, ɵ12 = () => import("./check-in/check-in.module.ngfactory").then(m => m.CheckInModuleNgFactory);
const routes = [
    { path: 'register-company/:eventAlias', loadChildren: ɵ0 },
    { path: 'register-investor/:eventAlias', loadChildren: ɵ1 },
    { path: 'register-seminar-investor/:eventAlias', loadChildren: ɵ2 },
    { path: 'external/company/:token', component: LoginLayoutComponent,
        children: [
            { path: '', component: ScheduleCompanyComponent,
                data: ɵ3
            }
        ]
    },
    { path: 'external/investor/:token', component: LoginLayoutComponent,
        children: [
            { path: '', component: ScheduleInvestorComponent,
                data: ɵ4
            }
        ]
    },
    { path: 'login/:eventAlias/company', component: LoginLayoutComponent,
        children: [
            { path: '', component: LoginComponent,
                data: ɵ5
            }
        ]
    },
    { path: 'login/:eventAlias/investor', component: LoginLayoutComponent,
        children: [
            { path: '', component: LoginComponent,
                data: ɵ6
            }
        ]
    },
    { path: 'login/admin', component: LoginAdminComponent, data: ɵ7 },
    {
        path: 'regis/:eventAlias', component: LoginLayoutComponent, canActivate: [AuthGuardGuard],
        children: [
            { path: 'company/:registerCompanyId/consent', component: CompanyConsentComponent, data: ɵ8 },
            { path: 'company/:registerCompanyId', component: CompanyComponent, data: ɵ9 },
            { path: 'investor/:registerInvestorId/consent', component: InvestorConsentComponent, data: ɵ10 },
            { path: 'investor/:registerInvestorId', component: InvestorComponent, data: ɵ11,
            },
        ]
    },
    { path: 'checkin/:eventAlias', loadChildren: ɵ12 },
    { path: 'session-timeout', component: UnauthorizeComponent }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12 };
